import fetch from 'cross-fetch';
import {getCsrfHeader, resToJson} from '../../common';
import { defaultTrackingId } from '../../helpers';

const GENERIC_ERROR_MSG = 'We could not process your request, please try again later.';

export function verifyAddress({ street1, city, state, country, postal_code }) {
  return fetch(`/api/validate_address/`, {
    method: 'POST',
    headers: {...getCsrfHeader()},
    body: JSON.stringify({ street1, city, state, country, postal_code }),
  }).then(resToJson);
}

export function createMember(sessionKey, contactInfo) {
  if (!sessionKey) return Promise.reject('session_key cannot be empty');
  return fetch (`/membership_api/create/${sessionKey}/`, {
    method: 'POST',
    body: JSON.stringify(contactInfo),
    headers: {...getCsrfHeader()}
  })
    .catch((error) => {
      return Promise.reject({
        error: 'createMember: Request failed.',
        display: GENERIC_ERROR_MSG
      });
    })
    .then(resToJson)
    .then(({data, status}) => {
      return data;
    });
}

export function integrateMember(sessionKey) {
  return fetch(`/membership_api/integrate/${sessionKey}/`).then(resToJson);
}

export function membershipOffers(trackingId, countryCode) {
  trackingId = trackingId || defaultTrackingId;
  const url = !countryCode
    ? `/membership_api/offers/${trackingId}/`
    : `/membership_api/offers/${trackingId}/${countryCode}/`;
  return fetch(url).then(resToJson);
}

export function sendDataToListrak(data, username) {
  const url = '/listrak/customer_feed/';
  const payload = {data, username};
  return fetch(url, {
    body: JSON.stringify(payload),
    headers: {...getCsrfHeader()},
    method: "POST"
  }).then(resToJson);
}
